
import { Options, Vue } from "vue-class-component";
import { useRoute } from "vue-router";
@Options({})
export default class PcPageMain extends Vue {
  private key = useRoute().path;
  created(): void {}
}
